module.exports = __webpack_public_path__ + "img/Powered-by.73bb3b20.png";